import { urls } from '../../../../identity-utils/src/urls';

// The pages whose page load issues `__Host-zbid`. The client imports this too,
// to load these pages in full rather than route to them, so keep it free of
// server-only imports.
export const ZBID_ISSUING_PATHS: ReadonlySet<string> = new Set([
  urls.LOGIN_URL,
  urls.FORGOT_PASSWORD_URL,
  urls.REAUTHENTICATE_URL,
  urls.SIGNUP_URL,
  // Normally the browser already has the cookie from /app/login by the time
  // it gets here; these cover browsers that arrive without one.
  urls.TWO_FACTOR_URL,
  urls.LOGIN_WITH_SSO_URL,
]);
